import { useIntl } from "react-intl";

import { ReactComponent as SaveIcon } from "assets/images/iconsV2/save-01.svg";
import Card from "components/v2/Card/Card";
import Button from "components/v2/Button/Button";

interface AccountMappingHeaderProps {
  showSave: boolean;
  isSaving: boolean;
  onSave: () => void;
}

export default function AccountMappingHeader({ showSave, isSaving, onSave }: AccountMappingHeaderProps) {
  const intl = useIntl();

  return (
    <Card.Header
      title={intl.formatMessage({
        id: "settings.side-menu.accountMapping",
        defaultMessage: "Account mapping",
      })}
      supportingText={intl.formatMessage({
        id: "settings.accountMapping.subtitle",
        defaultMessage: "Map Cargobase value to your company's custom",
      })}
      showBorder={false}
      actions={
        showSave ? (
          <Button
            testId="account-mapping-save"
            label={intl.formatMessage({ id: "general.save", defaultMessage: "Save" })}
            iconLeft={<SaveIcon />}
            onClick={onSave}
            disabled={isSaving}
          />
        ) : undefined
      }
    />
  );
}
